import { render, staticRenderFns } from "./GroupFieldSelector.vue?vue&type=template&id=22bf9883&scoped=true&"
import script from "./GroupFieldSelector.vue?vue&type=script&lang=js&"
export * from "./GroupFieldSelector.vue?vue&type=script&lang=js&"
import style0 from "./GroupFieldSelector.vue?vue&type=style&index=0&id=22bf9883&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf9883",
  null
  
)

export default component.exports